
<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.75 7C10.75 6.58579 10.4142 6.25 10 6.25C9.58578 6.25 9.25 6.58579 9.25 7H10.75ZM10 10H9.25C9.25 10.1989 9.32905 10.3897 9.46968 10.5303L10 10ZM11.3447 12.4053C11.6376 12.6982 12.1125 12.6982 12.4053 12.4053C12.6982 12.1124 12.6982 11.6376 12.4053 11.3447L11.3447 12.4053ZM1.96967 4.40717C1.67678 4.70007 1.67678 5.17493 1.96967 5.46783C2.26257 5.76072 2.73744 5.76072 3.03033 5.46783L1.96967 4.40717ZM5.28033 3.21783C5.57322 2.92493 5.57322 2.45007 5.28033 2.15717C4.98744 1.86428 4.51257 1.86428 4.21967 2.15717L5.28033 3.21783ZM16.9697 5.46783C17.2626 5.76072 17.7374 5.76072 18.0303 5.46783C18.3232 5.17493 18.3232 4.70007 18.0303 4.40717L16.9697 5.46783ZM15.7803 2.15717C15.4874 1.86428 15.0126 1.86428 14.7197 2.15717C14.4268 2.45007 14.4268 2.92493 14.7197 3.21783L15.7803 2.15717ZM16 10C16 13.3137 13.3137 16 10 16V17.5C14.1421 17.5 17.5 14.1421 17.5 10H16ZM10 16C6.68629 16 4 13.3137 4 10H2.5C2.5 14.1421 5.85786 17.5 10 17.5V16ZM4 10C4 6.68629 6.68629 4 10 4V2.5C5.85786 2.5 2.5 5.85786 2.5 10H4ZM10 4C13.3137 4 16 6.68629 16 10H17.5C17.5 5.85786 14.1421 2.5 10 2.5V4ZM9.25 7V10H10.75V7H9.25ZM9.46968 10.5303L11.3447 12.4053L12.4053 11.3447L10.5303 9.46968L9.46968 10.5303ZM3.03033 5.46783L5.28033 3.21783L4.21967 2.15717L1.96967 4.40717L3.03033 5.46783ZM18.0303 4.40717L15.7803 2.15717L14.7197 3.21783L16.9697 5.46783L18.0303 4.40717Z"
      fill="currentColor"
    />
  </svg>
</template>
<script>
export default {
  name: 'AlarmClockIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>
<style scoped>
</style>
